import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "video", "preview", "result",
    "livePanel", "placeholder",
    "btnStart", "btnCapture", "btnRetake"
  ]

  static values = { existingPhotoUrl: String }

  connect() {
    console.log("[Camera] connect()")
    this.stream = null
    const existing = this.existingPhotoUrlValue?.trim() || ""

    if (existing.length > 0) {
      console.log("[Camera] → foto existente:", existing)
      this._showPanel()
      this.previewTarget.src = existing
      this.previewTarget.style.display = "block"
      this._hidePlaceholder()
      if (this.hasBtnStartTarget)   this.btnStartTarget.style.display   = "none"
      if (this.hasBtnCaptureTarget) this.btnCaptureTarget.style.display = "none"
      if (this.hasBtnRetakeTarget)  this.btnRetakeTarget.style.display  = "inline-block"
    } else {
      // Auto-abre a câmera ao carregar o formulário de novo registro
      this.start()
    }
  }

  disconnect() {
    this._stopStream()
  }

  async start() {
    console.log("[Camera] start()")

    if (!navigator.mediaDevices?.getUserMedia) {
      console.warn("[Camera] getUserMedia não suportado")
      this._showError("Câmera não disponível neste navegador ou contexto (requer HTTPS ou localhost).")
      return
    }

    try {
      this._stopStream()
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user", width: { ideal: 640 }, height: { ideal: 480 } },
        audio: false
      })
      console.log("[Camera] stream obtido")

      this._clearError()
      this._showPanel()
      this._hidePlaceholder()

      // esconde preview, mostra vídeo
      this.previewTarget.style.display = "none"
      this.videoTarget.style.display   = "block"
      this.videoTarget.srcObject = this.stream

      if (this.hasBtnStartTarget)   this.btnStartTarget.style.display   = "none"
      if (this.hasBtnCaptureTarget) this.btnCaptureTarget.style.display = "inline-block"
      if (this.hasBtnRetakeTarget)  this.btnRetakeTarget.style.display  = "none"

    } catch (e) {
      console.error("[Camera] Erro ao acessar câmera:", e.name, e.message)

      if (e.name === "NotAllowedError") {
        this._showError("Permissão de câmera negada. Clique no ícone de câmera na barra de endereço do navegador e permita o acesso.")
      } else if (e.name === "NotFoundError") {
        this._showError("Nenhuma câmera encontrada neste dispositivo.")
      } else {
        this._showError(`Erro ao acessar câmera: ${e.message}`)
      }

      if (this.hasBtnStartTarget) this.btnStartTarget.style.display = "inline-block"
      if (this.hasBtnCaptureTarget) this.btnCaptureTarget.style.display = "none"
    }
  }

  capture() {
    console.log("[Camera] capture()")
    const video = this.videoTarget
    const canvas = document.createElement("canvas")
    canvas.width  = video.videoWidth  || 640
    canvas.height = video.videoHeight || 480

    const ctx = canvas.getContext("2d")
    ctx.translate(canvas.width, 0)
    ctx.scale(-1, 1)
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

    const dataUrl = canvas.toDataURL("image/jpeg", 0.92)
    console.log("[Camera] capturado, tamanho:", dataUrl.length)

    // para o stream e mostra o preview no mesmo painel
    this._stopStream()
    this.videoTarget.style.display   = "none"
    this.previewTarget.src           = dataUrl
    this.previewTarget.style.display = "block"
    this.resultTarget.value          = dataUrl

    if (this.hasBtnCaptureTarget) this.btnCaptureTarget.style.display = "none"
    if (this.hasBtnRetakeTarget)  this.btnRetakeTarget.style.display  = "inline-block"
  }

  retake() {
    console.log("[Camera] retake()")
    this.resultTarget.value          = ""
    this.previewTarget.style.display = "none"
    this.previewTarget.removeAttribute("src")
    this.start()
  }

  _showError(msg) {
    let el = this.element.querySelector("[data-camera-error]")
    if (!el) {
      el = document.createElement("p")
      el.setAttribute("data-camera-error", "")
      el.className = "text-danger small mt-1"
      this.element.querySelector("[data-camera-target='livePanel']")?.after(el)
    }
    el.textContent = msg
    el.style.display = "block"
  }

  _clearError() {
    const el = this.element.querySelector("[data-camera-error]")
    if (el) el.style.display = "none"
  }

  _showPanel() {
    if (this.hasLivePanelTarget) {
      this.livePanelTarget.style.display = "block"
    }
  }

  _hidePlaceholder() {
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.style.display = "none"
    }
  }

  _stopStream() {
    if (this.stream) {
      this.stream.getTracks().forEach(t => t.stop())
      this.stream = null
    }
    if (this.hasVideoTarget) this.videoTarget.srcObject = null
  }
}